export const COMPANY_NAME = 'NO SURF HOUSE';
export const COMPANY_SHORT = 'No Surf House';
export const COMPANY_INITIALS = 'NSH';
export const COMPANY_ADDRESS_FULL = '10820 BELLAIRE RD, CLEVELAND, OH 44111-5308';
export const COMPANY_LOCATION = 'Cleveland, Ohio';
export const COMPANY_REGION = 'West Side · Lake Erie';
export const COMPANY_TAGLINE = 'A landlocked lakeside house in West Cleveland.';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=10820%20BELLAIRE%20RD%2C%20CLEVELAND%2C%20OH%2044111-5308';

export const MARQUEE_WORDS = [
  'No Surf House',
  'Cleveland · Ohio',
  'Lake Erie · West Side',
  'Bellaire Road',
  'Est. House Profile',
];

export const PROFILE_FACTS = [
  { label: 'House', value: 'No Surf House' },
  { label: 'City', value: 'Cleveland, Ohio' },
  { label: 'Region', value: 'West Side · Lake Erie' },
  { label: 'Street', value: 'Bellaire Road' },
];

export const HOUSE_NOTES = [
  {
    number: '01',
    title: 'Lakeside, not coastline',
    body: 'Cleveland sits along Lake Erie, not the ocean — so the house leans on lake light, long lawns, and the slow hush of the West Side rather than any surfboard.',
  },
  {
    number: '02',
    title: 'A West Side address',
    body: 'The profile points to a single Bellaire Road location: a public-facing house identity tied to a quiet street rather than a busy storefront.',
  },
  {
    number: '03',
    title: 'Public-safe by design',
    body: 'Only the source-confirmed name, city, and street address are surfaced here. Registry numbers and tax identifiers stay off the page.',
  },
  {
    number: '04',
    title: 'Editorial, not operational',
    body: 'No hours, no staff, no contact form — the house is described, not opened. The layout exists to introduce it, not to transact.',
  },
];

export const PUBLIC_INFO = [
  { label: 'Name', value: COMPANY_NAME },
  { label: 'City', value: COMPANY_LOCATION },
  { label: 'Street', value: '10820 Bellaire Rd' },
];
